import constants from '../constants'
import FullName from '../components/Signup/FullName'
import DoctorLocation from '../containers/AnayaCare/Components/DoctorLocation'
import glucoliveLogo from '../assets/images/glucolive-sucess.webp'
import glucoliveWhiteLogo from '../assets/images/logos/glucolive-white-logo.webp'

export const GLUCOLIVE_CONFIG = {
  id: constants.CARE_PROGRAM_TYPE.GLUCOLIVE,
  name: 'GlucoLive CGM Program',
  drug_name: 'GlucoLive',
  campaign_link: `${process.env.REACT_APP_FE_URL}/onboarding`,
  medical_condition_group_id: null,
  upload_report_type: null,
  onboarding_steps: [
    {
      name: 'name',
      hideButton: true,
      Component: FullName,
      title: 'Enter your name',
      subtitle: 'We will refer to you by this name in the application.',
      hideImage: true,
    },
    {
      name: 'address',
      hideButton: true,
      Component: DoctorLocation,
      title: 'Your location',
      subtitle: 'We need your location to provide better service.',
      hideImage: true,
      canSkip: true,
    },
  ],
  success_image: glucoliveLogo,
  success_image_width: '100%',
  success_title: 'Registration completed successfully',
  showMetabolicScore: false,
  logoWhite: glucoliveWhiteLogo,
  partnerName: 'GlucoLive',
  success_message: () => (
    <>
      <b>GoodFlip</b> in partnership with
      <b> GlucoLive</b> <br /> Your trusted health partner.
    </>
  ),
}
